// extracted by mini-css-extract-plugin
module.exports = {"courseCardControls":"CourseCardControls__courseCardControls__2u15d"};